import { transformPoint, type Frame, type MeshBuilder } from '../mesh/meshBuilder';
import { buildRoof, type HouseStyles } from './houseParts';
import type { Body } from './houseFacades';
import type { HouseParams } from './types';
import type { DetailSink } from './detailSink';
import { buildChimneys, chimneyMouths } from './chimneys';

export function buildHouseRoof(
  builder: MeshBuilder,
  styles: HouseStyles,
  frame: Frame,
  body: Body,
  params: HouseParams,
  details: DetailSink
): void {
  buildRoof(builder, styles.roof, frame, body);
  buildChimneys(builder, styles.side, frame, body, params.chimneys, params.pitch);
  details.roof?.({
    from: transformPoint([body.x0, body.ridge, 0], frame),
    to: transformPoint([body.depth, body.ridge, 0], frame),
    chimneys: chimneyMouths(frame, body, params.chimneys),
  });
}
